/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsProductSection7 = {
  init: function ($section) {
    
    // Add settings from schema to current object
    // window.PXUTheme.jsProductSection7 = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];

    this.delegateElement = new domDelegate.Delegate($section[0]);
    this.domDelegate = new domDelegate.Delegate(document.body);
    
    this.intersectionOptions = {
      root: null,
      rootMargin: "0px",
      threshold: [0, 0.75, 0.95],
    }

    this.handleOddSlidesOffset();
    this.handleVideoIntersection();

    gsap.registerPlugin(ScrollTrigger);
    this.videos = gsap.utils.toArray(".Section_7--massonry--video", this.element);
    this.parallaxes = [];
    this.handleParallax();
    // window.addEventListener("resize", this.handleParallax.bind(this));
  },
  handleOddSlidesOffset() {
    let $this = this;
    function handleOffset() {
      let offsetContainer = $this.element.querySelector(".Section_7--massonry_container--content");
      let offsetAmount = offsetContainer.clientHeight;
      let videos = Array.from($this.element.querySelectorAll(".Section_7--massonry--video"));
      videos.forEach((video, index) => {
        if ( index % 2 === 0 && index > 1) {
          video.style.transform = `translateY(-${offsetAmount}px)`;
        }
      })
    }
    handleOffset();
    window.addEventListener("resize", handleOffset);
  },
  handleVideoIntersection() {
    let videos = Array.from(this.element.querySelectorAll(".ProductPageVideo"));
    videos.forEach( video => {
      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (window.PXUTheme.media_queries.large.matches) {
            if (entry.isIntersecting && entry.intersectionRatio > 0.75) {
              video.play();
            } else {
              video.pause();
            }
          } else {
            if (entry.isIntersecting) {
              video.play();
            } else {
              video.pause();
            }
          }
        });
      }, this.intersectionOptions);
      observer.observe(video);
    });
  },
  handleParallax() {
    if (window.innerWidth <= 798 && !this.parallaxEnabled) {
      this.videos.forEach((video, i) => {
        this.parallaxes.push(ScrollTrigger.create({
          trigger: video,
          start: () => video.offsetHeight < window.innerHeight ? "top top" : "bottom bottom",// if it's shorter than the viewport, we prefer to pin it at the top
          end: () => {
            if (i + 1 == this.videos.length) {
              return "bottom bottom";
            }},
          pin: true,
          pinSpacing: false
        }));
      });
      this.parallaxEnabled = true;
    } else if (window.innerWidth > 798 && this.parallaxEnabled) {
      this.parallaxes.forEach((parallax, i) => {
        parallax.kill(true)
      });
      this.parallaxEnabled = false;
    }

  }

}

/******/ })()
;